import {
  resolveRequestMeta,
  buildJavaUrl,
  isGraySchoolEnabled,
  isLoginPath,
  saveGraySchoolFlag,
  shouldDoubleRequestTimeout,
  shouldSaveGraySchoolFlagForPhpPath,
} from "./graySchoolRouting";
import {
  getAuthPayload,
  appendGetParams,
  appendPostBody,
  appendJavaHeaders,
} from "./requestAuth";

export function registerHttpInterceptors({
  axios,
  Tool,
  i18n,
  Urls,
  Message,
  flattenJavaEnvelope,
  getTokenincHolder,
  showFullScreenLoading,
  tryHideFullScreenLoading,
}) {
  axios.defaults.timeout = 40000;

  axios.interceptors.request.use(
    (config) => {
      const authPayload = getAuthPayload(Tool);
      const requestMeta = resolveRequestMeta(config, Urls);
      const method = (config.method || "").toLowerCase();
      config.__requestMeta = requestMeta;

      if (shouldDoubleRequestTimeout(requestMeta.pathname)) {
        const baseTimeout = Number(config.timeout || axios.defaults.timeout);
        if (baseTimeout > 0) {
          config.timeout = baseTimeout * 2;
        }
      }

      if (requestMeta.isCrmApi && !requestMeta.isPhpOnly && isGraySchoolEnabled(Tool)) {
        config.url = buildJavaUrl(requestMeta.pathname, requestMeta.search, Urls);
        appendJavaHeaders(config, authPayload);
      }

      const shouldInjectAuthParams = !isLoginPath(requestMeta.pathname);
      if (shouldInjectAuthParams) {
        if (method === "get") {
          appendGetParams(config, authPayload);
        } else if (method === "post" && typeof config.data === "string") {
          appendPostBody(config, authPayload);
        }
      }

      showFullScreenLoading();
      return config;
    },
    (error) => {
      tryHideFullScreenLoading();
      Message.error({
        message: i18n.t("Common.loadTip2"),
      });
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      tryHideFullScreenLoading();
      if (response.data) {
        response.data = flattenJavaEnvelope(response.data);
      }

      const requestMeta = response.config && response.config.__requestMeta;
      if (
        requestMeta &&
        requestMeta.isPhpOnly &&
        shouldSaveGraySchoolFlagForPhpPath(requestMeta.pathname)
      ) {
        const fallbackGrayValue = isLoginPath(requestMeta.pathname) ? 0 : null;
        saveGraySchoolFlag(response.data, Tool, fallbackGrayValue);
      }
      const tokenHolder = getTokenincHolder(response.data);
      if (
        tokenHolder &&
        tokenHolder.tokeninc != null &&
        tokenHolder.tokeninc == 0
      ) {
        Message.error({
          message: i18n.t("Common.loadTip3"),
        });
        window.localStorage.clear();
        window.location.replace(`${Urls.wpcUrl}/login`);
      }
      return response;
    },
    (error) => {
      tryHideFullScreenLoading();
      Message.error({
        message: i18n.t("Common.loadTip4"),
      });
      return Promise.reject(error);
    }
  );
}
